export default [
  [
    '#480000',
    '#7e2b2f',
    '#b5572a',
    '#ee982a',
    '#fecd75',
    '#f4f4c1',
    '#948dbe',
    '#464fae',
    '#383890',
    '#28256f',
    '#000016'
  ],
  [
    '#953c22',
    '#b65643',
    '#d67431',
    '#eea82d',
    '#fbe735',
    '#7ce92c',
    '#23ce34',
    '#27a57e',
    '#1f738c',
    '#1a3462',
    '#000018'
  ],
  [
    '#00000b',
    '#421559',
    '#633661',
    '#866064',
    '#a5916b',
    '#cacb6d',
    '#93a54e',
    '#63863a',
    '#396724',
    '#1d4a12',
    '#000000'
  ]
]
